export const formatCurrency = (cents) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(cents / 100);
};

export const CAMPAIGN_TYPE_LABELS = {
  annual: 'Annual',
  capital: 'Capital',
  endowment: 'Endowment',
  event_based: 'Event-Based',
  emergency_special_appeal: 'Emergency/Special Appeal',
};

// Donation frequency labels, shared so the modal and inline form stay in sync.
export const FREQUENCY_LABELS = {
  one_time: 'One Time',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  yearly: 'Yearly',
};

export const campaignTypeLabel = (type) => CAMPAIGN_TYPE_LABELS[type] || type;

export const CAMPAIGN_STATUS_DISPLAY = {
  planned: { label: 'Planned', variant: 'indigo' },
  receiving_gifts: { label: 'Receiving gifts', variant: 'blue' },
  active: { label: 'Active', variant: 'success' },
  ended: { label: 'Ended', variant: 'warning' },
  completed: { label: 'Completed', variant: 'gray' },
};

export const campaignStatusDisplay = (displayStatus) =>
  CAMPAIGN_STATUS_DISPLAY[displayStatus] || { label: displayStatus || '—', variant: 'gray' };

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric'
  });
};

export const formatDollars = (dollars) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(dollars);
};

// Like formatDollars but always shows cents — used for fee/total amounts
// (e.g. "$10.00", "$0.61") where the exact charge matters to the donor.
// Takes a dollar value (not cents, unlike formatCurrency above).
export const formatDollarsWithCents = (dollars) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(dollars);
};

export const parsePresetAmounts = (presetAmounts) =>
  (presetAmounts || '25,50,100,250,500').split(',').map(a => parseInt(a.trim(), 10)).filter(Boolean);

export const parseAmountDescriptions = (presetAmountDescriptions) => {
  if (!presetAmountDescriptions) return {};
  if (typeof presetAmountDescriptions === 'object' && !Array.isArray(presetAmountDescriptions)) return presetAmountDescriptions;
  try {
    const parsed = JSON.parse(presetAmountDescriptions);
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch { return {}; }
};

export const parseFrequencies = (enabledFrequencies) =>
  (enabledFrequencies || 'one_time,monthly').split(',').map(f => f.trim()).filter(Boolean);

export const daysLeftDisplay = (campaign) => {
  if (!campaign || campaign.format === 'form' || !campaign.end_date || campaign.display_status === 'completed') return null;
  if (campaign.past_end_date) {
    return { kind: 'past_due', endLabel: formatDate(campaign.end_date) };
  }
  if (campaign.days_remaining > 0) {
    return { kind: 'active', value: campaign.days_remaining };
  }
  return null;
};

export const escapeHtmlAttr = (str) => String(str || '')
  .replace(/&/g, '&amp;')
  .replace(/"/g, '&quot;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');

export const parseDedicationOptions = (dedicationOptions) => {
  const defaults = ['In Honor Of', 'In Memory Of'];
  if (!dedicationOptions) return defaults;
  if (Array.isArray(dedicationOptions)) return dedicationOptions;
  try {
    const parsed = JSON.parse(dedicationOptions);
    return Array.isArray(parsed) ? parsed : defaults;
  } catch { return defaults; }
};
